import React from 'react';
import { CardBody } from '../../shared/card/card-body';
import { Button, Icon } from '../../shared';
import './card-clients.scss';
import { services } from '../../../shared';
import saveAs from 'file-saver';
export var CardClientDownloadsBody = function (_a) {
    var documents = _a.documents;
    var getCustomerDocument = function (id, description, mimeType) {
        services.getCustomerDocument(id).then(function (blob) {
            saveAs(blob, "".concat(description, ".").concat(mimeType === null || mimeType === void 0 ? void 0 : mimeType.split('/')[1]));
        });
    };
    if (documents === null || documents === void 0 ? void 0 : documents.length) {
        var list = documents === null || documents === void 0 ? void 0 : documents.map(function (_a) {
            var id = _a.id, description = _a.description, formId = _a.formId, mimeType = _a.mimeType;
            return (React.createElement("div", { className: "s-card-client__detail", key: id },
                React.createElement("span", { className: "doc-upload__success" },
                    React.createElement(Icon, { name: "tick", colour: "primary" })),
                React.createElement("div", { className: "s-card-client__detail__content" },
                    React.createElement("span", null, description)),
                React.createElement(Button, { type: "button", variant: "secondary", icon: "download", iconPosition: "left", size: "small", onClick: function () { return getCustomerDocument(id, description, mimeType); } }, "Download")));
        });
        return React.createElement(CardBody, null, list);
    }
    return React.createElement(CardBody, null, 'No Documents');
};
